import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./universe.css";
import { LeftOutlined } from "@ant-design/icons";
import { Button, Checkbox, DatePicker, Row, Col, Spin, Pagination, message } from "antd";
import { isEmpty } from "lodash";

//svgs for calendar icons
import { ReactComponent as CalendarIcon } from "../../assets/calendar24x24.svg";
import { ReactComponent as ExpandArrow } from "../../assets/expand-icon-purple.svg";
import { ReactComponent as SearchIcon } from "../../assets/search-short-handle.svg"

import { useSelector, useDispatch } from "react-redux";

import { Input, Tooltip as AntTooltip } from "antd";
import ColoredBulletLink from "../../components/shared/ColoredBulletLink";
//import ByCountry from "../../components/byCountry/ByCountry";
import PdfViewer from "../../components/pdfViewer/PdfViewer";
//import categories
import { mainCategoryOptions as categories } from "../../data/data";
import { lawTypeOptions as lawtypes } from "../../data/data";

import { format, parseISO } from "date-fns";
import { downloadDocument } from "../../store/documents/actions";
import { sanitizeString } from "../../util/removeDashesFromString";

const { Search } = Input;
const { RangePicker } = DatePicker;

const prefix = <SearchIcon style={{ color: "purple" }} />;

const Universe = () => {
  const dispatchito = useDispatch();

  const user = useSelector(state => state.user);
  const laws = useSelector(state => state.laws.laws ?? []);
  const loading = useSelector(state => state.forms.loading);
  const filteredCategories = useSelector(state => state.laws.lawCategories);
  const filteredTypes = useSelector(state => state.laws.lawTypes);
  const documents = useSelector(state => state.documents?.laws ?? {});

  const [file, setFile] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [chosenCategories, setChosenCategories] = useState([]);
  const [chosenTypes, setChosenTypes] = useState([]);
  const [chosenRange, setChosenRange] = useState([]);
  const [results, setResults] = useState([]);

  // State for current page and items per page (for pagination)
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; //const [itemsPerPage, setItemsPerPage] = useState(4);

  //states for visible components
  const [pdfViewerTab, setPdfViewerTab] = useState(false); //initial value should be false (hidden)
  const [expandedSidebar, setExpandedSidebar] = useState(true); //initial value: false = hidden, true = visible

  //detect environment
  const isRunningOnVM1 = () => {
    return process.env.REACT_APP_FILE_HOST === "regcom-qa.grantthornton.gr";
  };
  const isRunningOnVM2 = () => {
    return process.env.REACT_APP_FILE_HOST === "regcom-uat.grantthornton.gr";
  };
  const isRunningOnLocalHost = () => {
    return process.env.REACT_APP_FILE_HOST === "localhost";
  };

  let pdfStringStart = "";

  if (isRunningOnLocalHost()) {
    pdfStringStart = "http://backend:4000";
  } else if (isRunningOnVM1()) {
    pdfStringStart = "https://regcom-qa.grantthornton.gr";
  } else if (isRunningOnVM2()) {
    pdfStringStart = "https://regcom-uat.grantthornton.gr";
  }

  //rerender for tab change based on the selection/unselection of file
  useEffect(() => {
    setPdfViewerTab(file ? true : false);
  }, [file]);

  //set results based on filters and search
  useEffect(() => {
    if (
      laws?.length &&
      filteredCategories?.length &&
      filteredTypes?.length
    ) {
      let newresults = laws.filter(x => {

        //if filter exists check and return validity of item else allow by default
        let categoryCheck = chosenCategories.length
          ? chosenCategories.includes(x.mainCategory)
          : filteredCategories.filter(item => item.value === x.mainCategory)
              ?.length > 0;
        let typeCheck = chosenTypes.length
          ? chosenTypes.includes(x?.type) ?? false
          : filteredTypes.filter(item => item.value === x?.type).length > 0 ??
            true;
        let rangeCheck = chosenRange.length
          ? (chosenRange[0]
              ? x.inForceDate.slice(0, 10) >= chosenRange[0]
              : true) &&
            (chosenRange[1]
              ? x.inForceDate.slice(0, 10) <= chosenRange[1]
              : true)
          : true;
        // console.debug(
        //   "checks",
        //   categoryCheck,
        //   typeCheck,
        //   rangeCheck,
        //   chosenCategories.length,
        //   chosenTypes.length,
        //   chosenRange.length
        // );

        if (searchTerm.length) {
          return categoryCheck && typeCheck && rangeCheck
            ? x.title.toLowerCase().match(searchTerm.toLowerCase()) ||
              x.description.toLowerCase().match(searchTerm.toLowerCase())
              ? true
              : false
            : false;
        } else {
          return categoryCheck && typeCheck && rangeCheck ? true : false;
        }
      });
      // console.debug(newresults);
      setResults(newresults);
      setCurrentPage(1); //return to first page of results
    }
  }, [
    chosenCategories,
    chosenTypes,
    chosenRange,
    laws,
    searchTerm,
    filteredCategories,
    filteredTypes,
  ]);

  // Calculate the current items to show based on the current page and items per page
  const currentItems = results
    ? results.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      )
    : [];

  //handle changes
  const onPageChange = page => {
    setCurrentPage(page);
  };

  const onChangeCategories = e => {
    // console.debug("change on checkboxes", e);
    setChosenCategories(e);
  };

  const onChangeTypes = e => {
    // console.debug("change on types", e);
    setChosenTypes(e);
  };

  const onChangeDate = e => {
    // console.debug("RANGE", e);
    let from =
      e && e[0]
        ? e[0]?.$y +
          "-" +
          (e[0]?.$M + 1).toString().padStart(2, "0") +
          "-" +
          e[0]?.$D.toString().padStart(2, "0")
        : "";
    let to =
      e && e[1]
        ? e[1]?.$y +
          "-" +
          (e[1]?.$M + 1).toString().padStart(2, "0") +
          "-" +
          e[1]?.$D.toString().padStart(2, "0")
        : "";
    // console.debug("RANGE change on date", from, to);
    let newRange = [from, to];
    setChosenRange(newRange);
  };

  //renderers
  const renderCategories = () => {
    return (
      <>
        {!isEmpty(filteredCategories) && filteredCategories.map(obj => {
          return (
            <>
              <Col
                span={12}
                key={`category-option-${obj.value.replaceAll(" ", "-")}-key`}
                className="category-checkbox"
                id={`category-option-${obj.value.replaceAll(" ", "-")}-id-1`}
              >
                <Checkbox
                  id={`category-option-${obj.value.replaceAll(" ", "-")}`}
                  className="checkbox-box"
                  value={obj.value}
                >
                  {obj.label}
                </Checkbox>
              </Col>
            </>
          );
        })}
      </>
    );
  };

  const renderTypes = () => {
    return (
      <>
        {!isEmpty(filteredTypes) && filteredTypes.map(obj => {
          return (
            <>
              <Col
                span={12}
                id={`type-option-${obj.value.replaceAll(" ", "-")}-id1`}
                key={`type-option-${obj.value.replaceAll(" ", "-")}-key`}
                className="types-checkbox"
              >
                <Checkbox
                  id={`type-option-${obj.value.replaceAll(" ", "-")}`}
                  className="checkbox-box"
                  value={obj.value}
                >
                  {obj.label}
                </Checkbox>
              </Col>
            </>
          );
        })}
      </>
    );
  };

  const renderTags = () => {
    return (
      <>
        {!isEmpty(filteredCategories) && filteredCategories.map(obj => {
          let active;
          if (pdfViewerTab) {
            // if pdf viewer tab visible decide based on file's category
            active = file.mainCategory && file.mainCategory === obj.value;
          } else {
            //else visible decide based on filter chosen categories
            active = chosenCategories.includes(obj.value);
          }
          return (
            <>
              <Link
                key={`tag-${obj.value}-key`}
                className={`${active ? "active" : "inactive"} ${
                  pdfViewerTab ? "flat" : "clickable"
                }`}
                id={`universe-${active ? "active" : "inactive"}-${
                  pdfViewerTab ? "flat" : "clickable"
                }-id`}
                to="#"
                onClick={() => {
                  //if not on pdf viewer tab, tags are clickable and update category filter
                  if (!pdfViewerTab) {
                    let newChosen;
                    if (active) {
                      newChosen = chosenCategories?.filter(
                        item => item !== obj.value
                      );
                    } else {
                      newChosen = [...chosenCategories, obj.value];
                    }
                    setChosenCategories(newChosen);
                  }
                }}
              >
                <ColoredBulletLink text={obj.label} />
              </Link>
            </>
          );
        })}
      </>
    );
  };

  const renderResults = results => {
    return results.length ? (
      <>
        <div id="universe-results-header">
          <span>Law</span>
          <span>Category</span>
          <span>Type</span>
          <span>In Force Date</span>
        </div>
        {results.map((item, index) => {
          return (
            <>
              <div
                className="universe-results-record"
                id={`id-universe-page-result-law-content-${index}`}
                key={item.pdfDocument.replaceAll(" ", "-")}
                type="default"
                obligation={item}
              >
                <div
                  className="result-law-content"
                  id="universe-page-result-law-content"
                >
                  <div>
                    <button
                      key={item._id}
                      id={`link-to-pdf-${item.pdfDocument.replaceAll(
                        " ",
                        "-"
                      )}`}
                      className="result-title"
                      onClick={() => {
                        // console.debug(item);
                        message.loading('Loading file...', 1)
                        dispatchito(
                          downloadDocument({
                            docId: documents?.[item._id]?.doc_id,
                            user,
                            callback: (url='') => {
                              let chosen = laws.find(
                                ({ _id }) => _id === item._id
                              );
                              chosen = {...chosen, url, filename: documents?.[item._id]?.name}
                              setFile(chosen)                              
                            }
                          })
                        );
                        //for laws in category 'Other' (meaning company specific laws) the path should include the company id
                        // if (item.mainCategory === "Other") {
                        //   chosen = {
                        //     ...chosen,
                        //     pdfDocument: `${chosen.organization}/${chosen.pdfDocument}`
                        //   };
                        // }
                        // console.debug(
                        //   `chosen pdf url >>> http://${
                        //     process.env.REACT_APP_FILE_HOST
                        //   }:4000/uploads/${
                        //     chosen ? chosen.pdfDocument : "default.pdf"
                        //   }`
                        // );
                        // setFile(chosen);
                      }}
                    >
                      {item.title}
                    </button>
                    <AntTooltip
                      overlayClassName="description-tooltip"
                      title={item?.description}
                      arrow={false}
                      mouseEnterDelay={0.5}
                      placement="bottomLeft"
                    >
                      <div
                        className="description-hover"
                        id={`universe-page-description-hover${index}`}
                      >
                        <p className="description">
                          {item?.description ?? "-"}
                        </p>
                      </div>
                    </AntTooltip>
                  </div>

                  <div>
                    {item.mainCategory
                      ? categories.find(obj => obj.value === item.mainCategory)
                          ?.label ?? "..."
                      : "-"}
                  </div>
                  <div>
                    {item.type
                      ? lawtypes.find(obj => obj.value === item.type)?.label ??
                        "..."
                      : "-"}
                  </div>
                  <div>{format(parseISO(item?.inForceDate), "d MMM yyyy")}</div>
                </div>
              </div>
            </>
          );
        })}
      </>
    ) : (
      "No results"
    );
  };

  return (
    <>
      {loading && <Spin size="large" />}
      {!loading && filteredCategories && filteredTypes && (
        <div className="universe-container" id="universe-page-container">
          <div
            className={
              expandedSidebar
                ? "universe-sidebar open"
                : "universe-sidebar closed"
            }
            id="universe-page-expanded-sidebar"
          >
            <div
              id="categories-checkbox"
              className="universe-filter checkboxes"
            >
              <div
                className="checkbox-header"
                id="universe-page-checkbox-header"
              >
                <label htmlFor="categories">Categories</label>
                <Button
                  id="clear-all-categories"
                  type="text"
                  style={{
                    marginLeft: "1.25rem"
                  }}
                  onClick={() => {
                    onChangeCategories([]);
                  }}
                >
                  Clear All
                </Button>
              </div>
              <div>
                <Checkbox.Group
                  id="categories"
                  style={{
                    width: "100%"
                  }}
                  onChange={onChangeCategories}
                  value={chosenCategories}
                >
                  <Row>{renderCategories()}</Row>
                </Checkbox.Group>
              </div>
            </div>
            <hr />
            <div id="types-checkbox" className="universe-filter checkboxes">
              <div
                className="checkbox-header"
                id="universe-page-checkbox-header-2"
              >
                <label htmlFor="types">Law Types</label>
                <Button
                  id="clear-all-types"
                  type="text"
                  style={{
                    marginLeft: "1.25rem"
                  }}
                  onClick={() => {
                    onChangeTypes([]);
                  }}
                >
                  Clear All
                </Button>
              </div>
              <div>
                <Checkbox.Group
                  id="types"
                  style={{
                    width: "100%"
                  }}
                  onChange={onChangeTypes}
                  value={chosenTypes}
                >
                  <Row>{renderTypes()}</Row>
                </Checkbox.Group>
              </div>
            </div>
            <hr />
            <div id="date-filter" className="universe-filter">
              <label htmlFor="universe-range-picker">In Force Date</label>
              <div>
                <RangePicker
                  id="universe-range-picker"
                  onChange={onChangeDate}
                  format={"DD/MM/YYYY"}
                  placeholder={["From", "To"]}
                  allowEmpty={[true, true]}
                  size="large"
                />
              </div>
            </div>
          </div>
          <ExpandArrow
            id="sidebar-drawer-button"
            className={expandedSidebar ? "open" : "closed"}
            type="text"
            onClick={() => {
              setExpandedSidebar(!expandedSidebar);
            }}
          />
          <div className="universe-content" id="universe-page-content">
            <Search
              className="search-bar"
              id={"universe-search-bar"}
              placeholder="Search"
              prefix={prefix}
              allowClear
              size="large"
              value={searchTerm || ""}
              onSearch={e => setSearchTerm(sanitizeString(e))}
              onChange={e => {
                if (pdfViewerTab) {
                  setFile("");
                }
                setSearchTerm(sanitizeString(e.target.value));
              }}
            />
            {/* <p id="universe-tags-label">
              {pdfViewerTab
                ? "Law Document related to: "
                : "Showing Results related to: "}
            </p> */}
            <div id="universe-category-tags">{renderTags()}</div>
            <hr />
            <div
              id="search-result-list"
              className={pdfViewerTab ? "hidden" : "visible"}
            >
              {/* {searchTerm ? renderResults() : 'Search something'} */}
              {renderResults(currentItems)}
              {/* Add Pagination component, with total pages calculated based on items per page and total items */}
              <Pagination
                current={currentPage}
                total={results ? results.length : 0}
                pageSize={itemsPerPage}
                hideOnSinglePage={true}
                showSizeChanger={false}
                onChange={onPageChange} // Handle page change
                style={{ display: "block" }}
                itemRender={(page, type, originalElement) => {
                  //custom render is used in order to be able to add ids on next and previous buttons for qa automation
                  if (type === "next") {
                    return (
                      <button
                        id="universe-pagination-next"
                        className="ant-pagination-item-link"
                        type="button"
                        tabindex="-1"
                      >
                        <span
                          role="img"
                          aria-label="right"
                          className="anticon anticon-right"
                          id="universe-page-anticon-right"
                        >
                          <svg
                            viewBox="64 64 896 896"
                            focusable="false"
                            data-icon="right"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
                          </svg>
                        </span>
                      </button>
                    );
                  } else if (type === "prev") {
                    return (
                      <button
                        id="universe-pagination-prev"
                        type="button"
                        className="ant-pagination-item-link"
                        tabindex="-1"
                      >
                        <span
                          role="img"
                          aria-label="left"
                          id="universe-page-anticon-left"
                          className="anticon anticon-left"
                        >
                          <svg
                            viewBox="64 64 896 896"
                            focusable="false"
                            data-icon="left"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path>
                          </svg>
                        </span>
                      </button>
                    );
                  }
                  return originalElement;
                }}
              />
            </div>
            <div
              id="pdf-view-tab"
              className={pdfViewerTab ? "visible" : "hidden"}
            >
              <Button
                id="back-to-results"
                type="text"
                style={{ width: "max-content" }}
                onClick={() => {
                  setFile("");
                }}
              >
                <LeftOutlined />
                Back to results
              </Button>
              <div className="law-details">
                <div id="lawDetailsHeader">
                  <h4 className="universe-info">{file.title}</h4>
                  <div id="calendarArea" className="universe-info">
                    <CalendarIcon />
                    <strong>In Force Date: </strong>
                    {file?.inForceDate
                      ? format(parseISO(file.inForceDate), "d MMM yyyy")
                      : "----------"}
                  </div>
                </div>
              </div>
              {/* <div id="universe-document-details">
                <p className="document-title">
                  {file.title ? file.title : "No Obligation Selected"}
                </p>
                <div className="document-dates">
                  <div>
                    <CalendarIcon1 /> <span>In Force Date</span>{" "}
                    {file.inForceDate
                      ? dateHelper(file.inForceDate)
                      : "----------"}
                  </div>
                </div>
              </div> */}
              {!isEmpty(file) && <PdfViewer
                id="pdf-viewer"
                fileUrl={file?.url ?? ""}
                fileName={file?.filename ?? "law_file.pdf"}
                // fileUrl={`${pdfStringStart}/uploads/${
                //   file ? file.pdfDocument : "default.pdf"
                // }`}
              />}
            </div>
          </div>
        </div>
      )}{" "}
    </>
  );
};

export default Universe;
